import { forwardRef } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';

export interface CustomPatternFormatProps extends Omit<
  PatternFormatProps,
  'onValueChange' | 'format'
> {
  name?: string;
  onChange: (event: { target: { name?: string; value: string } }) => void;
}

export const CustomPatternFormat = forwardRef<
  HTMLInputElement,
  CustomPatternFormatProps
>(function CustomPatternFormat(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      format='###-###-###-###'
      mask='_'
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.formattedValue,
          },
        });
      }}
    />
  );
});

export const IPAddressPatternFormat = forwardRef<
  HTMLInputElement,
  CustomPatternFormatProps
>(function IPAddressPatternFormat(props, ref) {
  const { onChange, name, onBlur, ...other } = props;

  const formatIpAddress = (value: string) => {
    const segments = value.split('.');

    if (segments.length !== 4) return value;

    return segments
      .map((segment) => {
        const numericSegment = segment.replace(/\D/g, '');

        return numericSegment.padStart(3, '0');
      })
      .join('.');
  };

  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      format='###.###.###.###'
      mask='_'
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.formattedValue,
          },
        });
      }}
      onBlur={(event) => {
        const cleanValue = event.target.value.replace(/_/g, '');
        const formattedValue = formatIpAddress(cleanValue);

        onChange({
          target: {
            name,
            value: formattedValue,
          },
        });

        onBlur?.(event);
      }}
    />
  );
});

export const TinPatternFormat = forwardRef<
  HTMLInputElement,
  CustomPatternFormatProps
>(function CustomPatternFormat(props, ref) {
  const { onChange, name, ...other } = props;

  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      format='###-###-###-#####'
      mask='_'
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.formattedValue,
          },
        });
      }}
    />
  );
});
